import { render } from "./PersonalStep.vue?vue&type=template&id=54c83a49"
import script from "./PersonalStep.vue?vue&type=script&lang=js"
export * from "./PersonalStep.vue?vue&type=script&lang=js"

import "./PersonalStep.vue?vue&type=style&index=0&id=54c83a49&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__